module.exports = __webpack_public_path__ + "abc2c1d27dc0ee50d414aeb81909632c.MP3";